// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .div-loading {
  width: 80px;
  left: 600px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--filled.mdc-text-field--no-label:hover {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;AACF;;AACA;EACE,kCAAA;AAEF;;AAAA;EACE,uBAAA;AAGF","sourcesContent":["::ng-deep .div-loading {\r\n  width: 80px;\r\n  left: 600px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--filled.mdc-text-field--no-label:hover {\r\n  background-color: white; \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
